/** @file dock-manager/StatusLegend.jsx — colour key at the bottom of the grid. */
import { Badge } from "@/components/ui/badge";
import { BOOKING_STATUSES, STATUS_BADGE_CLASS } from "@/lib/constants";
import HelpTip from "@/components/HelpTip";

export default function StatusLegend() {
  return (
    <div className="flex flex-wrap items-center gap-2 text-xs text-slate-500" data-testid="dock-status-legend">
      <span className="font-medium">Status colours:</span>
      {BOOKING_STATUSES.map((s) => (
        <Badge key={s.value} variant="secondary" className={STATUS_BADGE_CLASS[s.tone]}>
          {s.label}
        </Badge>
      ))}
      <HelpTip id="dock-status-legend">
        <div className="space-y-1">
          <p><strong>Pending</strong> — awaiting acceptance by a site admin (bay flagged approval-required).</p>
          <p><strong>Confirmed</strong> — accepted; driver will be emailed the slot details.</p>
          <p><strong>In progress</strong> — driver has arrived / checked in at the gate.</p>
          <p><strong>Completed</strong> — FLD signed off; goods logged.</p>
          <p><strong>No-show / Cancelled / NCR</strong> — closed states; NCR is used when there was a quality/compliance issue.</p>
        </div>
      </HelpTip>
    </div>
  );
}

